import NotFoundState from '@rio-cloud/rio-uikit/NotFoundState';
import { useIntl } from 'react-intl';

import { useCardOrders } from '@/api/cardOrders';
import CustomExpanderPanel from '@/features/administration/history/CustomExpanderPanel';
import OrderBody from '@/features/administration/history/OrderBody';
import OrderBodyDetails from '@/features/administration/history/OrderBodyDetails';
import OrderHeader from '@/features/administration/history/OrderHeader';
import OrderHistoryLoader from '@/features/administration/history/OrderHistoryLoader';
import { t } from '@/lib/utils';

const OrderHistory = () => {
    const { locale } = useIntl();
    const { data, isLoading, isError, refetch } = useCardOrders();

    const renderOrders = () => {
        if (!data?.cardOrderHistory || data.cardOrderHistory.length === 0) {
            return (
                <NotFoundState
                    headline={t('orderHistory.errorMessage.noOrdersFound.title')}
                    message={t('orderHistory.errorMessage.noOrdersFound.description')}
                    fullWidth={true}
                />
            );
        }
        return data.cardOrderHistory.map(order => (
            <CustomExpanderPanel
                key={order.orderId}
                header={<OrderHeader orderId={order.orderId} />}
                body={<OrderBody order={order} locale={locale} />}
                bodyDetails={<OrderBodyDetails order={order} locale={locale} />}
            />
        ));
    };

    if (isError) {
        return (
            <NotFoundState
                headline={t('orderHistory.errorMessage.unavailable.title')}
                message={t('orderHistory.errorMessage.unavailable.description')}
                buttons={[{ text: t('general.tryAgain'), onClick: () => refetch() }]}
                fullWidth={true}
            />
        );
    }

    return <>{isLoading ? <OrderHistoryLoader /> : renderOrders()}</>;
};

export default OrderHistory;
